<template>
  <div class="col-md-12 text-center wow fadeIn" data-wow-delay="300ms">
    <h2 class="heading bottom40 darkcolor font-light2">
      <span class="font-normal">Registrasi</span>
      <span class="divider-center"></span>
    </h2>
    <div class="col-md-8 offset-md-2 heading_space">
      <p>
        <!-- Lorem ipsum dolor sit amet, consectetur adipisicing elit. A dolores
        explicabo laudantium, omnis provident quam reiciendis voluptatum? -->
      </p>
    </div>
  </div>
  <div class="col-lg-6 col-md-12 col-sm-12 pr-lg-0 whitebox noshadow">
    <b-overlay :show="loadingCard" rounded="sm">
      <div class="widget logincontainer" v-if="!successRegister">
        <h3 class="darkcolor bottom35 text-center text-md-left">Buat Akun</h3>
        <Form
          class="border-form"
          id="register"
          :validation-schema="schema"
          @submit="submitRegister"
        >
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="form-group bottom25">
                <label for="registerName" class="d-none"></label>
                <Field
                  class="form-control"
                  name="name"
                  type="text"
                  placeholder="Nama Lengkap :"
                  v-model="registerData.name"
                  style="margin: 0px !important"
                />
                <ErrorMessage class="text-danger" name="name" />
              </div>
            </div>
            <div class="col-md-12 col-sm-12">
              <div class="form-group bottom25">
                <label for="nikNpwp" class="d-none"></label>
                <Field
                  class="form-control"
                  type="text"
                  name="nik_npwp"
                  placeholder="NIK / NPWP :"
                  v-model="registerData.nik_npwp"
                  style="margin: 0px !important"
                  maxlength="16"
                />
                <ErrorMessage class="text-danger" name="nik_npwp" />
              </div>
            </div>
            <div class="col-md-12 col-sm-12">
              <div class="form-group bottom25">
                <label for="registerEmail" class="d-none"></label>
                <Field
                  class="form-control"
                  type="email"
                  name="email"
                  placeholder="Email :"
                  v-model="registerData.email"
                  style="margin: 0px !important"
                />
                <ErrorMessage class="text-danger" name="email" />
              </div>
            </div>
            <div class="col-md-12 col-sm-12">
              <div class="form-group bottom25">
                <label for="registerPass" class="d-none"></label>
                <Field
                  class="form-control"
                  type="password"
                  name="password"
                  placeholder="Password :"
                  v-model="registerData.password"
                  style="margin: 0px !important"
                />
                <ErrorMessage class="text-danger" name="password" />
              </div>
            </div>
            <div class="col-md-12 col-sm-12">
              <div class="form-group bottom25">
                <label for="registerPassConfirm" class="d-none"></label>
                <Field
                  class="form-control"
                  type="password"
                  name="confirm_password"
                  placeholder="Konfirmasi Password :"
                  v-model="registerData.confirm_password"
                  style="margin: 0px !important"
                />
                <ErrorMessage class="text-danger" name="confirm_password" />
              </div>
            </div>
            <div class="col-md-12 col-sm-12">
              <div class="form-group bottom25">
                <label for="registerPassConfirm" class="d-none"></label>
                <Field
                  class="form-control"
                  type="text"
                  name="nomor_kontak"
                  placeholder="Nomor Kontak :"
                  v-model="registerData.nomor_kontak"
                  style="margin: 0px !important"
                />
                <ErrorMessage class="text-danger" name="nomor_kontak" />
              </div>
            </div>
            <div class="col-md-12 col-sm-12">
              <div class="form-group bottom25 text-center">
                <div class="d-flex w-100 justify-content-center">
                  <RecaptchaV2
                    @widget-id="handleWidgetId"
                    @error-callback="handleErrorCalback"
                    @expired-callback="handleExpiredCallback"
                    @load-callback="handleLoadCallback"
                    language="id"
                  />
                </div>
              </div>
            </div>
            <!-- <div class="col-md-12 col-sm-12">
            <div class="form-group bottom35">
              <div class="form-check text-left">
                <input
                  class="form-check-input"
                  checked
                  type="checkbox"
                  value=""
                  id="rememberMe"
                />
                <label class="form-check-label" for="rememberMe">
                  Remember me on this device
                </label>
              </div>
            </div>
          </div> -->
            <div class="col-sm-12">
              <button type="submit" class="button gradient-btn w-100">
                Daftar
              </button>
              <p class="top20 log-meta">
                Sudah Memiliki akun ? &nbsp;<a
                  href="/login"
                  class="defaultcolor"
                  >Masuk</a
                >
              </p>
            </div>
          </div>
        </Form>
        <!-- </el-form> -->
        <!-- </div> -->
      </div>
      <div v-else class="bg-white">
        <div class="row">
          <div class="col-md-12 text-center">
            <img src="/img/success-unscreen.gif" alt="" />
          </div>
          <div
            class="col-md-12 text-center"
            style="text-align: center !important"
          >
            <h3 class="darkcolor bottom35 text-center">Registrasi Berhasil</h3>
            <p class="text-center">
              Silahkan cek email anda untuk melakukan verifikasi akun
            </p>
          </div>

          <div class="col-12">
            <div class="mt-5"></div>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import { RecaptchaV2 } from "vue3-recaptcha-v2";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { useAuthStore } from "@/store/auth";
import { useToast, TYPE } from "vue-toastification";
import JwtService from "@/core/services/JwtService";

export default defineComponent({
  name: "RegisterView",
  components: {
    Form,
    Field,
    ErrorMessage,
    RecaptchaV2,
  },
  setup() {
    const loadingCard = ref(false);
    const authStore = useAuthStore();
    const toast = useToast();
    const successRegister = ref(false);

    const registerData: any = reactive({
      name: "",
      email: "",
      password: "",
      confirm_password: "",
      nomor_kontak: "",
      nik_npwp: "",
      recaptcha_token: "",
    });

    const schema = yup.object({
      name: yup.string()
      .required((data) => `Nama tidak boleh kosong !`)
      .matches(/^[a-zA-Z\s.\-']+$/, "Nama lengkap hanya boleh berisi huruf dan tanda baca dasar"),
      email: yup
        .string()
        .required((data) => `Email tidak boleh kosong !`)
        .email((data) => `Email tidak valid !`),
      password: yup
        .string()
        .required("Password tidak boleh kosong !")
        .min(8, "Password minimal 8 karakter")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])/,
          "Password harus mengandung huruf besar (A-Z), huruf kecil (a-z), angka (0-9), dan karakter spesial (!@#$%^&*)"
        ),
      confirm_password: yup
        .string()
        .required("Konfirmasi password tidak boleh kosong !")
        .oneOf([yup.ref("password"), null], "Password tidak sama"),
      nomor_kontak: yup
        .string()
        .required("Nomor kontak tidak boleh kosong !")
        .matches(/^[0-9]+$/, "Nomor kontak harus angka")
        .min(10, "Nomor kontak minimal 10 karakter")
        .max(13, "Nomor kontak maksimal 13 karakter"),
      nik_npwp: yup
        .string()
        .required("NIK / NPWP tidak boleh kosong !")
        .matches(/^[0-9]+$/, "NIK / NPWP harus angka")
        .min(15, "NIK / NPWP minimal 15 karakter")
        .max(16, "NIK / NPWP maksimal 16 karakter"),
    });

    const handleWidgetId = (widgetId: number) => {
      // console.log("Widget ID: ", widgetId);
    };
    const handleErrorCalback = () => {
      // console.log("Error callback");
      registerData.recaptcha_token = "";
    };
    const handleExpiredCallback = () => {
      // console.log("Expired callback");
      registerData.recaptcha_token = "";
    };
    const handleLoadCallback = (response: unknown) => {
      // console.log("Load callback", response);
      registerData.recaptcha_token = response;
    };

    const submitRegister = async () => {
      if (registerData.recaptcha_token == "") {
        return;
      }

      const { value: accept } = await Swal.fire({
        title: "Apakah anda yakin ?",
        text: "Pastikan data yang anda masukkan sudah benar !",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Tidak",
      });

      if (!accept) {
        return;
      }

      loadingCard.value = true;
      await authStore
        .register(registerData)
        .then((response) => {
          loadingCard.value = false;
          successRegister.value = true;
        })
        .catch((error) => {
          loadingCard.value = false;
          toast.error(error.response.data.data, {
            timeout: 5000,
            type: TYPE.ERROR,
          });
        });
    };

    onMounted(() => {
      if (authStore.isAuthenticated) {
        const rediirectAdmin =
          process.env.VUE_APP_ADMIN_URL_REDIRECT + JwtService.getToken();
        window.location.href = rediirectAdmin;
      }
    });

    return {
      registerData,
      schema,
      handleWidgetId,
      handleErrorCalback,
      handleExpiredCallback,
      handleLoadCallback,
      submitRegister,
      loadingCard,
      successRegister,
    };
  },
});
</script>

<style scoped>
.g-recaptcha {
  transform: scale(0.77);
  -webkit-transform: scale(0.77);
  transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
}
</style>
